if (typeof ModalBox !== "function") {
  class ModalBox extends HTMLElement {
    constructor() {
      window.inertElems = document.querySelectorAll("[data-js-inert]");

      super();

      this._prefix = window.KT_PREFIX || "";
      this.o = {
        ...{
          show: 10,
          showOnPageOffset: -1,
          frequency: "day",
          enabled: true,
          exitIntent: false,
          exitIntentIdleDelay: 30,
          exitIntentScrollDepth: 0.1,
          exitIntentScrollUpDistance: 0.1,
          exitIntentTopThreshold: 10,
          showOnce: true,
          closeByKey: true,
          disableScroll: true,
          enableClose: false,
          type: false,
          blockTabNavigation: false,
          blockInteraction: false,
          closeOnOverlay: false,
          openedModalBodyClass: `${this._prefix}modal-opened`,
        },
        ...JSON.parse(this.dataset.options),
      };

      this._modalKey = `modal-${document.location.hostname}-${this.id}`;
      this._modalText = this.querySelector("[data-content]")?.textContent || "";
      this._automaticSessionKey = this.classList.contains("popup--newsletter")
        ? `newsletter-popup-auto-shown-${document.location.hostname}`
        : null;
      this._showTimer = null;
      this._exitIntentIdleTimer = null;
      this._exitIntentTriggered = false;
      this._exitIntentReadyAt = 0;
      this._inertElements = [];
      this._lastFocusedElm = null;
      this._pendingShow = null;
      this._pendingPopup = null;
      this._pendingPopupHiddenHandler = null;
      this._hydrateHeaderLogo();

      if (this.o.type == "cookies") {
        this.o.enabled = false;

        const showBanner = () => {
          this.o.enabled = true;
          this.show();
        };

        const cookiesAccept = () => {
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              analytics: true,
              marketing: true,
              preferences: true,
            },
            () => {},
          );
        };
        const cookiesDecline = () => {
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              analytics: false,
              marketing: false,
              preferences: false,
            },
            () => {},
          );
        };

        const initCookieBanner = () => {
          if (window.Shopify.customerPrivacy.shouldShowBanner()) {
            showBanner();
          }
        };

        this.querySelector("[data-js-cookies-accept]").addEventListener(
          "click",
          cookiesAccept,
        );
        this.querySelector("[data-js-cookies-decline]").addEventListener(
          "click",
          cookiesDecline,
        );

        window.Shopify.loadFeatures(
          [
            {
              name: "consent-tracking-api",
              version: "0.1",
            },
          ],
          (error) => {
            if (error) {
              throw error;
            }
            initCookieBanner();
          },
        );
      }

      if (this.o.type == "age_verification") {
        this.o.enabled = false;
        this.o.closeByKey = false;
        this._initAgeVerification();
      }

      this._scrollTriggered = false;

      if (this.o.enabled) {
        this._modalStorage = !localStorage.getItem(this._modalKey)
          ? "empty"
          : JSON.parse(localStorage.getItem(this._modalKey));

        const timeNow = new Date().getTime();
        const inBetween = Math.round(
          (timeNow - this._modalStorage["shown"]) / 1000,
        );

        let showModal = false;

        if (
          this._modalStorage == "empty" ||
          (this.o.frequency == "day" && inBetween > 86400) ||
          (this.o.frequency == "week" && inBetween > 604800) ||
          (this.o.frequency == "month" && inBetween > 2419200) ||
          (!this._automaticSessionKey &&
            this._modalStorage["content"] != this._modalText)
        ) {
          showModal = true;
        }

        if (showModal && this._automaticDisplayAllowed()) {
          if (
            this.o.automaticDisplayMode == "desktop_exit_only" ||
            this.o.exitIntent ||
            this.o.type == "exit_intent_popup"
          ) {
            this._initExitIntent();
          } else if (this.o.showOnPageOffset > 0) {
            this._onScroll = () => {
              const scrollPercent =
                (window.scrollY /
                  (document.documentElement.scrollHeight -
                    window.innerHeight)) *
                100;
              if (
                scrollPercent >= this.o.showOnPageOffset &&
                !this._scrollTriggered
              ) {
                this._scrollTriggered = true;
                this._showTimer = setTimeout(
                  () => {
                    this.show(false, { automatic: true });
                  },
                  parseInt(this.o.show * 1000),
                );
                window.removeEventListener("scroll", this._onScroll);
              }
            };
            window.addEventListener("scroll", this._onScroll, {
              passive: true,
            });
          } else {
            this._showTimer = setTimeout(
              () => {
                this.show(false, { automatic: true });
              },
              parseInt(this.o.show * 1000),
            );
          }
        }
        this.querySelectorAll("[data-js-close]").forEach((elm) =>
          elm.addEventListener("click", () => {
            this.hide(this.o.showOnce);
          }),
        );
      } else {
        this.querySelectorAll("[data-js-close]").forEach((elm) =>
          elm.addEventListener("click", () => {
            this.hide(this.o.showOnce);
          }),
        );
      }

      if (this.o.enableClose == true) {
        this.querySelectorAll("[data-js-close]").forEach((elm) =>
          elm.addEventListener("click", () => {
            this.hide(this.o.showOnce);
          }),
        );
      }

      if (this.o.closeByKey) {
        document.addEventListener("keydown", (e) => {
          if (e.keyCode == 27) {
            if (this.classList.contains(`${this._prefix}active`)) {
              this.hide(this.o.showOnce);
            }
          }
        });
      }

      if (this.o.closeOnOverlay && this.o.type !== "age_verification") {
        this.addEventListener("click", (event) => {
          if (
            event.target === this &&
            this.classList.contains(`${this._prefix}active`)
          ) {
            this.hide(this.o.showOnce);
          }
        });
      }
    }

    disconnectedCallback() {
      if (this._showTimer) {
        clearTimeout(this._showTimer);
        this._showTimer = null;
      }
      this._clearExitIntentListeners();
      this._clearPendingShow();
    }

    _hasFinePointer() {
      return (
        window.matchMedia?.("(hover: hover) and (pointer: fine)").matches ===
        true
      );
    }

    _hasAutomaticShownThisSession() {
      if (!this._automaticSessionKey) {
        return false;
      }

      try {
        return sessionStorage.getItem(this._automaticSessionKey) === "true";
      } catch (error) {
        console.warn("Unable to read popup session preference.", error);
        return false;
      }
    }

    _markAutomaticShownThisSession() {
      if (!this._automaticSessionKey) {
        return;
      }

      try {
        sessionStorage.setItem(this._automaticSessionKey, "true");
      } catch (error) {
        console.warn("Unable to save popup session preference.", error);
      }
    }

    _automaticDisplayAllowed() {
      if (this.o.automaticDisplayMode == "disabled") {
        return false;
      }
      if (this._hasAutomaticShownThisSession()) {
        return false;
      }
      if (
        this.o.automaticDisplayMode == "desktop_exit_only" &&
        !this._hasFinePointer()
      ) {
        return false;
      }

      return true;
    }

    _initExitIntent() {
      if (window.Shopify?.designMode) {
        return;
      }

      const minimumDelay =
        Math.max(0, Number.parseFloat(this.o.show) || 0) * 1000;
      this._exitIntentReadyAt = Date.now() + minimumDelay;

      const hasFinePointer = this._hasFinePointer();

      if (hasFinePointer) {
        this._initDesktopExitIntent();
      } else if (this.o.automaticDisplayMode != "desktop_exit_only") {
        this._initMobileExitIntent();
      }
    }

    _initDesktopExitIntent() {
      this._exitIntentLastMouseY = null;
      this._exitIntentMouseMoveHandler = (event) => {
        this._exitIntentLastMouseY = event.clientY;
      };
      this._exitIntentMouseOutHandler = (event) => {
        const leftThroughTop =
          event.relatedTarget === null &&
          event.clientY <= this.o.exitIntentTopThreshold;
        const movingUp =
          this._exitIntentLastMouseY === null ||
          event.clientY <= this._exitIntentLastMouseY;

        if (leftThroughTop && movingUp) {
          this._triggerExitIntent();
        }
      };

      document.addEventListener(
        "mousemove",
        this._exitIntentMouseMoveHandler,
        { passive: true },
      );
      document.addEventListener("mouseout", this._exitIntentMouseOutHandler);
    }

    _initMobileExitIntent() {
      const scrollableHeight = Math.max(
        document.documentElement.scrollHeight - window.innerHeight,
        0,
      );
      this._exitIntentMobileScrollDepth = Math.min(
        160,
        Math.max(80, scrollableHeight * this.o.exitIntentScrollDepth),
      );
      this._exitIntentMobileScrollUpDistance = Math.min(
        120,
        Math.max(
          60,
          window.innerHeight * this.o.exitIntentScrollUpDistance,
        ),
      );
      this._exitIntentMobileMaxScrollY = Math.max(0, window.scrollY);
      this._exitIntentMobileLastScrollY = this._exitIntentMobileMaxScrollY;
      this._exitIntentMobileInteracted = this._exitIntentMobileMaxScrollY > 0;
      this._exitIntentMobileViewedContent =
        this._exitIntentMobileMaxScrollY >=
        this._exitIntentMobileScrollDepth;

      this._exitIntentMobileInteractionHandler = () => {
        this._exitIntentMobileInteracted = true;
        this._scheduleMobileExitIntentIdle();
      };
      this._exitIntentMobileScrollHandler = () => {
        const currentScrollY = Math.max(0, window.scrollY);
        this._exitIntentMobileInteracted = true;
        this._exitIntentMobileMaxScrollY = Math.max(
          this._exitIntentMobileMaxScrollY,
          currentScrollY,
        );

        if (
          this._exitIntentMobileMaxScrollY >=
          this._exitIntentMobileScrollDepth
        ) {
          this._exitIntentMobileViewedContent = true;
        }

        const isScrollingUp =
          currentScrollY < this._exitIntentMobileLastScrollY;
        const upwardDistance =
          this._exitIntentMobileMaxScrollY - currentScrollY;

        this._exitIntentMobileLastScrollY = currentScrollY;
        this._scheduleMobileExitIntentIdle();

        if (
          this._exitIntentMobileViewedContent &&
          isScrollingUp &&
          upwardDistance >= this._exitIntentMobileScrollUpDistance
        ) {
          this._triggerExitIntent();
        }
      };

      document.addEventListener(
        "pointerdown",
        this._exitIntentMobileInteractionHandler,
        { passive: true },
      );
      window.addEventListener("scroll", this._exitIntentMobileScrollHandler, {
        passive: true,
      });

      if (this._exitIntentMobileInteracted) {
        this._scheduleMobileExitIntentIdle();
      }
    }

    _scheduleMobileExitIntentIdle() {
      if (
        !this._exitIntentMobileInteracted ||
        this._exitIntentTriggered
      ) {
        return;
      }

      if (this._exitIntentIdleTimer) {
        clearTimeout(this._exitIntentIdleTimer);
      }

      const idleDelay =
        Math.max(0, Number.parseFloat(this.o.exitIntentIdleDelay) || 0) *
        1000;
      const minimumDelay = Math.max(0, this._exitIntentReadyAt - Date.now());

      this._exitIntentIdleTimer = setTimeout(() => {
        this._triggerExitIntent();
      }, Math.max(idleDelay, minimumDelay));
    }

    _triggerExitIntent() {
      if (
        this._exitIntentTriggered ||
        Date.now() < this._exitIntentReadyAt ||
        window.Shopify?.designMode ||
        this.classList.contains(`${this._prefix}active`) ||
        document.querySelector("modal-box.popup--age_verification.active")
      ) {
        return false;
      }

      if (this.show(false, { automatic: true })) {
        this._exitIntentTriggered = true;
        this._clearExitIntentListeners();
        return true;
      }

      return false;
    }

    _clearExitIntentListeners() {
      if (this._exitIntentMouseMoveHandler) {
        document.removeEventListener(
          "mousemove",
          this._exitIntentMouseMoveHandler,
        );
        this._exitIntentMouseMoveHandler = null;
      }
      if (this._exitIntentMouseOutHandler) {
        document.removeEventListener(
          "mouseout",
          this._exitIntentMouseOutHandler,
        );
        this._exitIntentMouseOutHandler = null;
      }
      if (this._exitIntentMobileInteractionHandler) {
        document.removeEventListener(
          "pointerdown",
          this._exitIntentMobileInteractionHandler,
        );
        this._exitIntentMobileInteractionHandler = null;
      }
      if (this._exitIntentMobileScrollHandler) {
        window.removeEventListener(
          "scroll",
          this._exitIntentMobileScrollHandler,
        );
        this._exitIntentMobileScrollHandler = null;
      }
      if (this._exitIntentIdleTimer) {
        clearTimeout(this._exitIntentIdleTimer);
        this._exitIntentIdleTimer = null;
      }
    }

    _hydrateHeaderLogo() {
      const logoTarget = this.querySelector("[data-popup-logo]");
      if (!logoTarget) {
        return;
      }

      const headerLogo =
        document.querySelector(
          "#logo .logo-img:not(.logo-alt-img) img",
        ) || document.querySelector("#logo .logo-txt");

      if (!headerLogo) {
        logoTarget.hidden = true;
        return;
      }

      const logo = headerLogo.cloneNode(true);
      logo.removeAttribute("class");
      logo.removeAttribute("style");
      logo.removeAttribute("tabindex");
      logo.removeAttribute("loading");

      if (logo instanceof HTMLAnchorElement) {
        logo.className = "popup-logo__text";
        logo.removeAttribute("href");
      }

      logoTarget.replaceChildren(logo);
    }

    _initAgeVerification() {
      const confirmButton = this.querySelector(
        "[data-age-verification-confirm]",
      );
      const denyButton = this.querySelector("[data-age-verification-deny]");

      confirmButton?.addEventListener("click", () => {
        try {
          localStorage.setItem(this.o.ageVerificationStorageKey, "true");
        } catch (error) {
          console.warn("Unable to save age verification preference.", error);
        }

        this.hide(false);
      });

      denyButton?.addEventListener("click", (event) => {
        event.preventDefault();

        const question = this.querySelector("[data-age-verification-question]");
        const deniedState = this.querySelector(
          "[data-age-verification-denied]",
        );

        try {
          localStorage.removeItem(this.o.ageVerificationStorageKey);
        } catch (error) {
          console.warn("Unable to clear age verification preference.", error);
        }

        if (question) {
          question.hidden = true;
          question.setAttribute("aria-hidden", "true");
        }
        if (deniedState) {
          deniedState.hidden = false;
          deniedState.removeAttribute("aria-hidden");
          deniedState.focus();
        }

        this.classList.add("age-verification--denied");
      });

      let isVerified = false;
      try {
        isVerified =
          localStorage.getItem(this.o.ageVerificationStorageKey) === "true";
      } catch (error) {
        console.warn("Unable to read age verification preference.", error);
      }

      if (!isVerified) {
        setTimeout(() => {
          this.show();
        }, 0);
      }
    }

    _queueShow(blockingPopup, customContent, options) {
      this._pendingShow = { customContent, options };
      if (this._pendingPopup === blockingPopup) {
        return;
      }

      this._clearPendingShowListener();
      this._pendingPopup = blockingPopup;
      this._pendingPopupHiddenHandler = () => {
        const pendingShow = this._pendingShow;
        this._pendingShow = null;
        this._clearPendingShowListener();
        if (pendingShow) {
          this.show(pendingShow.customContent, pendingShow.options);
        }
      };
      blockingPopup.addEventListener(
        "theme:modal-box:hidden",
        this._pendingPopupHiddenHandler,
        { once: true },
      );
    }

    _clearPendingShowListener() {
      if (this._pendingPopup && this._pendingPopupHiddenHandler) {
        this._pendingPopup.removeEventListener(
          "theme:modal-box:hidden",
          this._pendingPopupHiddenHandler,
        );
      }
      this._pendingPopup = null;
      this._pendingPopupHiddenHandler = null;
    }

    _clearPendingShow() {
      this._clearPendingShowListener();
      this._pendingShow = null;
    }

    show(customContent = false, options = {}) {
      const automatic = options.automatic === true;
      if (automatic && !this._automaticDisplayAllowed()) {
        return false;
      }

      if (
        this.classList.contains(`${this._prefix}active`) ||
        this.hasAttribute("data-modal-opening")
      ) {
        return false;
      }

      const popupLayer = this.closest(".stacked-popups");
      const blockingPopup = Array.from(
        popupLayer?.querySelectorAll(
          "modal-box.active, modal-box[data-modal-opening]",
        ) || [],
      ).find((popup) => popup !== this);
      if (blockingPopup) {
        this._queueShow(blockingPopup, customContent, options);
        return true;
      }

      this._clearPendingShow();

      this._clearExitIntentListeners();

      if (this._showTimer) {
        clearTimeout(this._showTimer);
        this._showTimer = null;
      }

      if (customContent && document.querySelector(customContent)) {
        const content = document.querySelector(customContent).innerHTML;
        const modalCommon = document.getElementById("modal-common");
        if (modalCommon) {
          modalCommon.innerHTML = content;
          if (this.o.enableClose == true) {
            modalCommon.querySelectorAll("[data-js-close]").forEach((elm) =>
              elm.addEventListener("click", () => {
                this.hide(this.o.showOnce);
              }),
            );
          }
        }
      }

      this._lastFocusedElm =
        document.activeElement instanceof HTMLElement
          ? document.activeElement
          : null;

      this.setAttribute("data-modal-opening", "");
      this.style.removeProperty("display");
      if (automatic) {
        this._markAutomaticShownThisSession();
      }
      setTimeout(() => {
        this.removeAttribute("data-modal-opening");
        this.classList.add(`${this._prefix}active`);
        if (this.classList.contains("popup--enhanced")) {
          this.closest(".stacked-popups")?.classList.add(
            "stacked-popups--modal-active",
          );
        }
        if (this.o.disableScroll) {
          document.body.classList.add(this.o.openedModalBodyClass);
        }
        if (this.o.blockInteraction || this.o.blockTabNavigation) {
          this._setPageInert();
        }
      }, 10);

      setTimeout(() => {
        if (this.querySelector("[data-js-first-focus]")) {
          this.querySelector("[data-js-first-focus]").focus();
        } else {
          this.focus();
        }
      }, 250);

      return true;
    }

    hide(remember = false) {
      this.removeAttribute("data-modal-opening");
      this.classList.remove(`${this._prefix}active`);
      document.body.classList.remove(this.o.openedModalBodyClass);
      this._clearPopupHash();
      setTimeout(() => {
        this.style.display = "none";
        if (this.classList.contains("popup--enhanced")) {
          const popupLayer = this.closest(".stacked-popups");
          if (
            popupLayer &&
            !popupLayer.querySelector(".popup--enhanced.active")
          ) {
            popupLayer.classList.remove("stacked-popups--modal-active");
          }
        }
        this.dispatchEvent(new CustomEvent("theme:modal-box:hidden"));
      }, 500);
      if (remember && !Shopify.designMode) {
        localStorage.setItem(
          this._modalKey,
          JSON.stringify({
            shown: new Date().getTime(),
            content: this._modalText,
          }),
        );
      }

      this._releasePageInert();
      const focusTarget = this._lastFocusedElm || window.lastFocusedElm;
      if (focusTarget) {
        setTimeout(() => {
          focusTarget.focus();
          this._lastFocusedElm = null;
          window.lastFocusedElm = null;
        }, 100);
      }
    }

    _clearPopupHash() {
      if (
        !this.dataset.popupId ||
        window.location.hash !== `#popup-${this.dataset.popupId}`
      ) {
        return;
      }

      window.history.replaceState(
        window.history.state,
        "",
        `${window.location.pathname}${window.location.search}`,
      );
    }

    _setPageInert() {
      this._releasePageInert();

      const bodyChildContainingModal = Array.from(document.body.children).find(
        (element) => element === this || element.contains(this),
      );

      Array.from(document.body.children).forEach((element) => {
        if (
          element !== bodyChildContainingModal &&
          !element.hasAttribute("inert")
        ) {
          element.setAttribute("inert", "");
          this._inertElements.push(element);
        }
      });

      if (bodyChildContainingModal && bodyChildContainingModal !== this) {
        Array.from(bodyChildContainingModal.children).forEach((element) => {
          if (
            element !== this &&
            !element.contains(this) &&
            !element.hasAttribute("inert")
          ) {
            element.setAttribute("inert", "");
            this._inertElements.push(element);
          }
        });
      }
    }

    _releasePageInert() {
      this._inertElements.forEach((element) => {
        element.removeAttribute("inert");
      });
      this._inertElements = [];
    }
  }

  if (typeof customElements.get("modal-box") == "undefined") {
    // Clone modal elements and move to end of body IF append-top-body
    const originalElements = document.querySelectorAll("modal-box");
    originalElements.forEach((originalElement) => {
      const dataOptions = JSON.parse(originalElement.dataset.options);
      if (dataOptions.appendToBody === true) {
        document.body.appendChild(originalElement);
      }
    });

    customElements.define("modal-box", ModalBox);
  }

  // Shopify events

  document.addEventListener("shopify:section:select", (e) => {
    if (e.target.classList.contains("mount-popup")) {
      e.target.querySelector("modal-box").style.display = "block";
      e.target.querySelector("modal-box").show();
    }
  });
  document.addEventListener("shopify:block:select", (e) => {
    if (e.target.hasAttribute("data-modal-box")) {
      e.target.style.display = "block";
      e.target.show();
    }
  });
  document.addEventListener("shopify:block:deselect", (e) => {
    if (e.target.hasAttribute("data-modal-box")) {
      e.target.hide();
    }
  });
  document.addEventListener("shopify:section:deselect", (e) => {
    if (e.target.classList.contains("mount-popup")) {
      e.target.querySelector("modal-box").hide();
    }
  });

  const findPopupById = (popupId) => {
    const normalizedId = String(popupId || "")
      .replace(/^#?popup-/, "")
      .trim();

    return Array.from(
      document.querySelectorAll("modal-box[data-popup-id]"),
    ).find((popup) => popup.dataset.popupId === normalizedId);
  };

  const openPopupById = (popupId) => {
    const popup = findPopupById(popupId);
    if (!popup) {
      return false;
    }

    popup.show();
    return true;
  };

  window.openThemePopup = openPopupById;
  window.closeThemePopup = (popupId) => {
    const popup = findPopupById(popupId);
    if (!popup) {
      return false;
    }

    popup.hide(false);
    return true;
  };

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const dataTrigger = event.target.closest("[data-popup-open]");
    const hashTrigger = event.target.closest('a[href^="#popup-"]');
    const trigger = dataTrigger || hashTrigger;

    if (!trigger) {
      return;
    }

    const popupId = dataTrigger
      ? dataTrigger.dataset.popupOpen
      : hashTrigger.getAttribute("href");

    if (openPopupById(popupId)) {
      event.preventDefault();
    }
  });

  const openPopupFromHash = () => {
    if (window.location.hash.startsWith("#popup-")) {
      openPopupById(window.location.hash);
    }
  };

  window.addEventListener("hashchange", openPopupFromHash);
  openPopupFromHash();
}
